import type { Node as ProseMirrorNode } from "@tiptap/pm/model"

/** Не вставлять пробел после чипа, если сразу после позиции уже пробел/перевод строки. */
export function shouldInsertSpaceAfterMention(doc: ProseMirrorNode, pos: number): boolean {
  if (pos < 0 || pos >= doc.content.size) return true
  const next = doc.textBetween(pos, Math.min(pos + 1, doc.content.size), "\n", "\0")
  return next.length === 0 || !/\s/.test(next)
}
